import React, { useContext } from 'react'
import { SettingProviderStep4 } from 'app/React/Components/Form/Step4/SettingContextStep4'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SettingContainerStep4({ children }) {
  const {
    cartItems,
    currentVariant,
    setCartItems
  } = useContext(ConfiguratorContext)

  const accessories = currentVariant.accessories ?? [];

  const contextObject = {
    markChecked: (id) => {
      const newCartItems = [...cartItems]
      const newCartItemsIndex = newCartItems.findIndex((newCartItem) => String(newCartItem.id) === String(id))
      if (newCartItemsIndex !== -1) {
        return
      }

      const option = accessories.find(accessory => String(accessory.id) === id)
      if (option === undefined) {
        return
      }

      newCartItems.push(option.accessory)
      setCartItems(newCartItems)
    },

    markUnchecked: (id) => {
      // const cartItemKeyValues = Object.fromEntries(Object.entries(cartItems).map(([key, cartItem], index) => [cartItem.setting_id, cartItem.id]))
      const newCartItems = [...cartItems]
      const newCartItemsIndex = newCartItems.findIndex((newCartItem) => String(newCartItem.id) === String(id))

      if (newCartItemsIndex !== -1) {
        newCartItems.splice(newCartItemsIndex, 1)
      }

      setCartItems(newCartItems)
    },

    isChecked: (id) => {
      const cartItemIds = Object.values(cartItems).map(cartItem => String(cartItem.id))

      return cartItemIds.includes(String(id))
    }
  }

  return (
    <SettingProviderStep4 value={contextObject}>
      {children}
    </SettingProviderStep4>
  )
}
